<h3 class="login-message">
  {{ "redirect.message" | translate }}
</h3>
<div class="login-wrapper">
  @if (loading) {
    <mat-progress-spinner mode="indeterminate" class="login-loader"></mat-progress-spinner>
  } @else {
    <button mat-button (click)="triggerLogin()" class="login-button">
      {{ "redirect.button" | translate }}
      <mat-icon svgIcon="login"></mat-icon>
    </button>
  }
</div>
